import React, { useState } from "react";
import styles from "./NewsletterModal.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import CustomSwitch from "../../../Switch/Switch";
import TimeSelector from "./TimeSelector/TimeSelector";
import CustomButton from "../../../CustomButton/CustomButton";
import CustomSelect from "../../../CustomSelect/CustomSelect";
import { useTranslation } from "react-i18next";

const NewsletterModal = ({ setModalOpen }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.newsletterModal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            {t("newsletterModal.addNewsletterTitle")}
          </h2>
          <ExitIcon onClick={() => setModalOpen(false)} />
        </div>

        <div className={styles.switchItem}>
          <CustomSwitch /> <p>{t("newsletterModal.active")}</p>
        </div>
        <div className={styles.switchItem}>
          <CustomSwitch />
          <p>{t("newsletterModal.sendToChats")}</p>
        </div>
        <label htmlFor="">{t("newsletterModal.selectChannel")}</label>
        <CustomSelect
          placeholder={t("newsletterModal.channelNamePlaceholder")}
        />
        {/* <div className={styles.textTypeSelect}>
          <button className={styles.textTypeItem}>
            {t("newsletterModal.writeYourself")}
          </button>
          <button className={styles.textTypeItem}>
            {t("newsletterModal.generateAI")}
          </button>
        </div> */}
        <label htmlFor="">{t("newsletterModal.messageLabel")}</label>
        <textarea
          className={styles.modalTextarea}
          name=""
          id=""
          placeholder={t("newsletterModal.messagePlaceholder")}
        ></textarea>
        <label htmlFor="">{t("newsletterModal.delayLabel")}</label>
        <TimeSelector />
        <div className={styles.datePickerFooter}>
          <CustomButton onClick={() => setModalOpen(false)}>
            {t("newsletterModal.cancelButton")}
          </CustomButton>
          <CustomButton blue>{t("newsletterModal.saveButton")}</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default NewsletterModal;
